import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { StaffAuthProvider } from './auth/StaffAuthContext';
import { AppSessionProvider } from './context/AppSessionContext';
import { ToastProvider } from './context/ToastContext';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <StaffAuthProvider>
          <AppSessionProvider>
            <App />
          </AppSessionProvider>
        </StaffAuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
